class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.key, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus')

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target.id.includes('cart-drawer-offer-input-')) return;
    this.updateQuantity(event.target.dataset.key, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantities(lines, quantityUpdated, formData = null) {
    let config = fetchConfig();
    if (formData) {
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
    } else {
      const updates = lines.reduce((accumulator, line) => {
        accumulator[line] = quantityUpdated;
        return accumulator;
      }, {});

      config.body = JSON.stringify({
        updates: updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
    }

    fetch(`${routes.cart_update_url}`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

          const cartDrawerMain = elementToReplace.querySelector('.cart-drawer-main');
          if (cartDrawerMain && cartDrawerMain.scrollHeight > cartDrawerMain.clientHeight) {
            cartDrawerMain.scrollTo({
              top: cartDrawerMain.scrollHeight,
              behavior: 'smooth'
            });
          }
        }));

        this.disableLoading();
      }).catch((err) => {
        console.error(err);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  /**
   * Add line items to the cart
   * @param {FormData} formData 
   */
  async addLineItems(formData) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    try {
      const res = await fetch(`${routes.cart_add_url}`, config);
      const response = await res.json();

      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-offer',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        return;
      } else if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }


      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-offer',
        productVariantId: formData.get('id') ?? formData.get('items[0][id]'),
        lineItem: JSON.parse(this.dataset.productAnalytics ?? "{}"),
        list_id: null,
        list_name: null
      });

      cart.renderContents(response);
    } catch (err) {
      console.error(err);
    } finally {
      if (cart && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
    }
  }

  updateQuantity(line, quantityUpdated, name, triggerEvent = true) {
    this.enableLoading(line);

    const previousLineItem = document.querySelector(`[id^="CartItem-"][data-key="${line}"]`) || document.querySelector(`[id^="CartDrawer-Item-"][data-key="${line}"]`);
    const productScriptTag = previousLineItem.querySelector('[id^="Product-Item-Data-"]');

    const body = JSON.stringify({
      id: line,
      quantity: quantityUpdated,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        const removeButton = previousLineItem.querySelector('cart-remove-button');
        const { productHandle, variantId, quantity, skinType, scent, hairType, keyIngredient } = removeButton.dataset;

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          if (!parsedState.sections) return;
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.querySelector(`[id^="CartItem-"][data-key="${line}"]`) || document.querySelector(`[id^="CartDrawer-Item-"][data-key="${line}"]`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();

        document.dispatchEvent(new CustomEvent('productQuantityChange', {
          detail: {
            newQuantity: parseInt(quantityUpdated, 10),
            productData: productScriptTag ? JSON.parse(productScriptTag.innerHTML) : {}
          }
        }));

        if (quantityUpdated === 0 && triggerEvent) {
          document.dispatchEvent(new CustomEvent('removeFromCart', {
            detail: {
              productHandle,
              variantId,
              quantity,
              scent,
              skin_type: skinType,
              hair_type: hairType,
              key_ingredient: keyIngredient,
              cart: parsedState
            }
          }));
        } else if (triggerEvent) {
          document.dispatchEvent(new CustomEvent('updateProductQuantity', {
            detail: {
              cart: parsedState
            }
          }));
        }
      }).catch((err) => {
        console.error(err);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateQuantities(lines, quantityUpdated, formData = null) {
    let config = fetchConfig();
    if (formData) {
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
    } else {
      const updates = lines.reduce((accumulator, line) => {
        accumulator[line] = quantityUpdated;
        return accumulator;
      }, {});

      config.body = JSON.stringify({
        updates: updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
    }

    fetch(`${routes.cart_update_url}`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          // Fallback for browsers that don't support View Transitions:
          if (!document.startViewTransition) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          } else {
            document.startViewTransition(() => {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            });
          }
        }));

        this.disableLoading();
      }).catch((err) => {
        console.error(err);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  renderContents(parsedState) {
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.querySelector(`[id^="Line-item-error-"][data-key="${line}"]`) || document.querySelector(`[id^="CartDrawer-LineItemError-"][data-key="${line}"]`);
      const quantityElement = document.querySelector(`[id^="Quantity-"][data-key="${line}"]`) || document.querySelector(`[id^="Drawer-quantity-"][data-key="${line}"]`);

      if (lineItemError && quantityElement) {
        lineItemError
          .querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            quantityElement.value
          );
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    console.log(selector, new DOMParser().parseFromString(html, 'text/html').querySelector(selector))
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`[id^="CartItem-"][data-key="${line}"] .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`[id^="CartDrawer-Item-"][data-key="${line}"] .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};